export var createAttribute = function createAttribute(mapSubscribableThing, mutations, prependSubscribableThing) {
  return function (htmlElement, name) {
    var getAttribute = function getAttribute() {
      return htmlElement.getAttribute(name);
    };
    return prependSubscribableThing(mapSubscribableThing(mutations(htmlElement, {
      attributeFilter: [name],
      childList: false,
      subtree: false
    }), function () {
      return getAttribute();
    }), getAttribute());
  };
};